










import {Component, Watch} from "vue-property-decorator"
import AbpBase from "../../../lib/abpbase"
import {GetPropagandaPlan} from "@/api/propaganda"
import Detail from './parts/detail.vue'
import {GetUsers} from "@/api/dialysisProcess"

@Component({
	components: {Detail}
})
export default class EducationPlan extends AbpBase{
	position = ''
	buttons = ['我的患者', '今日宣教', '无计划患者']
	data:any = []
	detailData:any = []
	detailShow = false
	loading = false
	medicalStaff: Array<any> = [] // 所有的医护

	columns = [
		{
			title: '姓名',
			key: 'patientName',
			width: 200
		},
		{
			title: '宣教日期',
			key: 'planDate',
			width: 200
		},
		{
			title: '标题',
			key: 'resourceTitle'
		},
		{
			title: ' ',
			width: 220,
			render:(h:any, p:any)=>{
				return h('div',[
					h('Button',{
						props: {type: 'primary'},
						style:{marginRight: '10px'},
						on:{
							click:()=>{
								this.detail(p)
							}
						}
					},'详情'),
					h('Button',{
						props: {type: 'primary'},
						on:{
							click:()=>{
								this.history(p)
							}
						}
					},'宣教历史')
				])

			}
		},
	]
	created(){
		this.getData()
		this.getSelects()
	}
	@Watch('position')
	async getData(){
		this.loading = true
		let res = await GetPropagandaPlan({Type: this.position})
		this.data = res.objects
		this.loading = false
	}

	private detail(p: any) {
		this.detailData = {data: p}
		this.detailShow = true
	}
	history(p: any){
		this.detailData = {
			data: p,
			mode: 'history'
		}
		this.detailShow = true
	}

	private async getSelects() {
		let res = await GetUsers({})
		this.medicalStaff = res.objects.filter((item:any) => {
			return item.userName !== 'admin'
		})
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/education/educationPlan/index.vue